export default __webpack_public_path__ + "static/media/Frame1.24207447.png";